// @flow

import * as React from "react";
// import { useSelector } from "react-redux";

import { type ImageType, type LinkType } from "../../types";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as RingMobile } from "../../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-detail-fill.svg";
import Breadcrumbs from "../molecules/Breadcrumbs";
import MediaGallery from "./MediaGallery";
import Icon from "../atoms/Icon";
import LinkHandler from "../atoms/LinkHandler";
import { PrimaryNavPad } from "./PrimaryNav";
// import { add } from "date-fns";

type PropsType = {
    theme: "purple" | "orange" | "green" | "teal" | "pink" | "red" | "blue",
    logo: ImageType,
    title: string,
    description?: string,
    breadcrumbs: any,
    email: string,
    website?: LinkType,
    facebook?: LinkType,
    youtube?: LinkType,
    tiktok?: LinkType,
    twitter?: LinkType,
    media: {
        image: ImageType,
        youtube_url: LinkType,
        caption?: string,
    }[],
};

const SocialLink = (props): React.Node => {
    if (props.social) {
        return (
            <LinkHandler
                aria-label={props.name}
                to={props.social.url}
                target={props.social.target}
            >
                <span
                    className={`hero-club-detail__social-link__icon hero-club-detail__social-link__icon--${props.name}`}
                >
                    <Icon name={props.name} />
                </span>
            </LinkHandler>
        );
    } else {
        return null;
    }
};

const HeroClubDetail = (props: PropsType): React.Node => {
    const baseClassName = "hero-club-detail";
    const classes = [baseClassName];

    const orderedSocialLinks = [
        "facebook",
        "instagram",
        "tiktok",
        "twitter",
        "discord",
        "snapchat",
        "link",
        "linkedin",
    ];

    if (props.theme) {
        classes.push(`${baseClassName}--${props.theme}`);
    }

    return (
        <div className={classes.join(" ")}>
            <div className="hero-club-detail__inner">
                <PrimaryNavPad />
                <div className="hero-club-detail__container container-fluid">
                    {/* Design elements */}
                    <Circle className="hero-club-detail__circle" />
                    <Ring className="hero-club-detail__ring" />
                    <RingMobile className="hero-club-detail__ring-mobile" />
                    <Triangle className="hero-club-detail__triangle" />

                    <div className="hero-club-detail__row row">
                        <div className="col-xs-12 col-sm-6 col-md-7 hero-club-detail__left-content">
                            <Breadcrumbs breadcrumbs={props.breadcrumbs} />
                            <MediaGallery
                                mode="header"
                                media={props.media}
                                logo={props.logo}
                                theme={props.theme}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-5 col-lg-4 col-lg-offset-1">
                            <div className="hero-club-detail__right-content">
                                <Breadcrumbs breadcrumbs={props.breadcrumbs} />
                                <h2 className="hero-club-detail__title">
                                    {props.title}
                                </h2>
                                <p className="hero-club-detail__description">
                                    {props.description}
                                </p>
                                {props.email ? (
                                    <div className="hero-club-detail__link">
                                        <a
                                            href={`mailto:${props.email}`}
                                            target=""
                                        >
                                            <Icon name="email" width="16px" />
                                            <span className="text">
                                                {props.email}
                                            </span>
                                        </a>
                                    </div>
                                ) : null}
                                {props.website ? (
                                    <div className="hero-club-detail__link">
                                        <LinkHandler
                                            to={props.website.url}
                                            target={props.website.target}
                                        >
                                            <Icon name="globe" width="18px" />
                                            <span className="text">
                                                {props.website.url}
                                            </span>
                                        </LinkHandler>
                                    </div>
                                ) : null}
                                <div className="hero-club-detail__social-link">
                                    {orderedSocialLinks.map(
                                        (name: string): React.Node => (
                                            <SocialLink
                                                key={name}
                                                name={name}
                                                social={props[name]}
                                            />
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

HeroClubDetail.defaultProps = {
    theme: "purple",
};

export default HeroClubDetail;
